import React from 'react';
import { motion } from 'framer-motion';
import { CreditCard, ShieldCheck } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { CountdownTimer } from './CountdownTimer';
export function PricingSection() {
  return <section className="py-24 px-4 bg-white relative overflow-hidden" data-id="element-148">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-violet-100/50 via-white to-white pointer-events-none" data-id="element-149" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-150">
        <div className="text-center mb-12" data-id="element-151">
          <h2 className="text-4xl md:text-5xl font-display font-bold text-gray-900 mb-6" data-id="element-152">
            Elegí Tu Camino de Transformación
          </h2>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl shadow-2xl border-2 border-violet-500 p-8 md:p-12 text-center relative overflow-hidden" data-id="element-153">
          {/* Discount Badge */}
          <div className="absolute top-6 right-6 bg-red-500 text-white font-bold px-4 py-2 rounded-full rotate-12 shadow-lg animate-pulse" data-id="element-154">
            -85% OFF
          </div>

          <p className="text-gray-500 text-xl line-through mb-2" data-id="element-155">
            Valor Total: $49.990
          </p>

          <div className="flex items-center justify-center gap-2 mb-4" data-id="element-156">
            <span className="text-6xl md:text-8xl font-bold text-gray-900 tracking-tight" data-id="element-157">
              $19.990
            </span>
            <span className="text-gray-500 self-end mb-4 font-medium" data-id="element-158">ARS</span>
          </div>

          <p className="text-violet-600 font-medium mb-8 bg-violet-50 inline-block px-4 py-2 rounded-lg" data-id="element-159">
            O en hasta 12 cuotas sin interés
          </p>

          <div className="mb-8 scale-90 md:scale-100" data-id="element-160">
            <CountdownTimer data-id="element-161" />
            <p className="text-red-500 text-sm font-medium mt-4 animate-pulse" data-id="element-162">
              ⚠️ Este precio especial vence cuando el contador llegue a cero
            </p>
          </div>

          <CTAButton text="¡QUIERO TRANSFORMAR MI VIDA AHORA!" size="xl" className="w-full md:w-auto mb-8" data-id="element-163" />

          {/* Payment Methods */}
          <div className="flex flex-wrap justify-center gap-4 text-sm text-gray-500 mb-8 border-t border-gray-100 pt-8" data-id="element-164">
            <span className="flex items-center gap-1" data-id="element-165">
              <CreditCard className="w-4 h-4" data-id="element-166" /> Tarjeta de crédito
            </span>
            <span data-id="element-167">•</span>
            <span data-id="element-168">Débito</span>
            <span data-id="element-169">•</span>
            <span data-id="element-170">Mercado Pago</span>
            <span data-id="element-171">•</span>
            <span data-id="element-172">Transferencia</span>
          </div>

          {/* Guarantee */}
          <div className="flex items-center justify-center gap-3 bg-gray-50 p-4 rounded-xl border border-gray-100" data-id="element-173">
            <ShieldCheck className="w-8 h-8 text-green-500 shrink-0" data-id="element-174" />
            <p className="text-sm text-gray-600 text-left" data-id="element-175">
              <strong data-id="element-176">Garantía de satisfacción de 7 días</strong>
              <br data-id="element-177" />
              Si no es lo que esperabas, te devolvemos el 100% de tu dinero.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}